export default __webpack_public_path__ + "7ca7a06eacef2b128cc21d5a15094c48.svg";